import { Directive, HostListener, Input, EventEmitter, Output } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

import { SystemMessageService, SystemMessage } from '../../../core/system-message/system-message-service';
import { validateForm } from '../form-validateForm.function';

@Directive({
    selector: '[pcgSubmitUrl]',
    standalone: false
})
export class SubmitUrlDirective {

	@Input('pcgSubmitUrl') url!: string;
	@Input() additionalFields: any;
	@Output() messageReceive: EventEmitter<SystemMessage> = new EventEmitter<SystemMessage>();
	@Output() messageSuccess: EventEmitter<SystemMessage> = new EventEmitter<SystemMessage>();
	@Output() messageError: EventEmitter<SystemMessage> = new EventEmitter<SystemMessage>();

	constructor(
        public formGroupDirective: FormGroupDirective
        , public ms: SystemMessageService
    ) { }

	@HostListener('submit', ['$event']) onSubmit($event: any) {
		if (this.formGroupDirective.form.valid) {
			// Send system message save event if form valid
            this.ms.getHttpObservable(this, this.url, this.formGroupDirective.form, this.additionalFields)
                .subscribe((msg: SystemMessage) => {
                    this.messageReceive.emit(msg);
                    if (msg && msg.isSuccessful) {
                        this.messageSuccess.emit(msg);
                    }
                    if (msg && !msg.isSuccessful) {
                        this.messageError.emit(msg);
                    }
                }
			);
		} else {
			// If form is not valid, show validation errors
			validateForm(this.formGroupDirective.form);
		}
	}
}
